import { TncDocumentTemplate } from '../../models/interfaces/terms-and-conditions.interface';

export const APPLICANT_SUBMISSION_CONSENT: TncDocumentTemplate = {
  document_name: 'applicant_submission_consent',
  version: '2026-02-23',
  content: {
    intro: 'We, the current and proposed flat owner(s) declare that:',
    items: [
      {
        id: '1',
        text: 'The particulars given in this Application Form are true and correct, and we have not withheld any information required in this Application Form.',
      },
      {
        id: '2',
        text: 'Other than the persons (if any) listed in the Declaration of Ownership of Private Property, neither we, our spouse(s) nor any persons listed in this application [including all authorised occupiers listed in this Application Form],',
        children: [
          {
            id: 'a',
            text: 'own or have an estate or interest in any other flat, house, building or land; or',
          },
          {
            id: 'b',
            text: 'have at any time within 30 months immediately prior to the date of application sold any other flat [e.g. HDB/JTC/HUDC/Executive Condominium etc], house, buildings or land or divested ourselves of any interest in such a property; or',
          },
          {
            id: 'c',
            text: 'have not made any arrangements or promises or entered into any agreement with other persons in the sale/parting of possession of the said flat.',
          },
        ],
      },
      {
        id: '3',
        text: 'We are not undischarged bankrupt(s) and/or have not had bankruptcy proceedings filed against us at any point of time. [Undischarged bankrupts and/or parties who have had bankruptcy proceedings filed against them at any point of time must obtain prior approval from the Official Assignee for the change in flat ownership]',
      },
      {
        id: '4',
        text: 'There are no outstanding judgements against us or court cases pending against us.',
      },
      {
        id: '5',
        text: 'We do not suffer, nor are we aware that we are suffering from any mental disorder or impairment. We have also not been diagnosed to suffer from these mental conditions, which will affect our understanding of the nature and effect of this Change in Flat Ownership. Further, there is no fraud or undue pressure inducing or forcing us directly or indirectly to give our consent and authority to the Change in Flat Ownership.',
      },
      {
        id: '6',
        text: 'We have read and understood the <a href="https://hdb.gov.sg/cs/infoweb/-/media/doc/HMG/change-in-flat-ownership-terms-and-conditions.pdf" target="_blank" rel="noopener noreferrer">Terms & Conditions</a> for Change in Flat Ownership attached and accept that the HDB shall have the right to unilaterally introduce new terms and conditions, at any time, even if such new terms and conditions may adversely affect our eligibility for the change in flat ownership.',
      },
      {
        id: '7',
        text: 'The HDB shall have the right to reject any application with incomplete information or applications deemed ineligible for whatever reason.',
      },
      {
        id: '8',
        text: 'We understand and accept that:',
        children: [
          {
            id: 'a',
            text: 'The HDB has the right to reject/cancel this application notwithstanding that approval may have been granted, at any time whensoever if we become ineligible to own the HDB flat or if we, our spouse or any of the persons listed have between the date of this application and the date of completion of the change in flat ownership acquired/sold any flat, house, building or land or acquired/divested any interest therein as owner thereof or through a nominee without HDB’s prior approval /exemption.',
          },
          {
            id: 'b',
            text: 'If any information given in this Application Form is false or incorrect or if we have withheld any information required in the form, our application shall be rejected and HDB shall be entitled to revoke the approval which it may have granted for the change in ownership of the HDB flat. In such event, all monies paid will be forfeited by the HDB.',
          },
        ],
      },
      {
        id: '9',
        text: 'We authorise the HDB to have access to and request any information regarding our account(s) with the CPF Board and to release our particulars to CPF Board for the purpose of or relating to or in connection with this application. We understand and agree that HDB shall rely on its own records and/or the records of other relevant authorities to obtain or verify any information relating to or in connection with the application. In this regard, we authorise HDB to write to and request for information from all the applicants and relevant authorities for any information in connection with the application.',
      },
      {
        id: '10',
        text: 'We authorise the HDB to have access to and request any information regarding our account(s) with the CPF Board and to release our particulars to CPF Board in the event that we are taking a loan from HDB and there are any instalment arrears for payment of the HDB mortgage loan owing on my/our flat after the completion of the change in flat ownership.',
        note: {
          text: '*Please delete this clause if proposed owners choose not to authorise HDB to access their CPF balances in the event if they are in any arrears of their HDB mortgage instalment subsequently.',
        },
      },
      {
        id: '11',
        text: 'We understand that the relevant provisions in the Bankruptcy Act / Insolvency Restructuring & Dissolution Act and any other relevant legislation relating to gift transactions may apply if there is any future transaction on this flat within 5 years and/or other applicable timeframe from the date this transaction is finalised.',
      },
    ],
  },
};
